/*
 * Softeo
 *
 * Author: Anthony LEFOYE
 * Copyright (c) 2023-2024 Prodeo - All Rights Reserved
 */

const API_AUTH_CONST = Object.freeze( {
  CODE_MIN_LENGTH: 8,
  CODE_MAX_LENGTH: 8
} );

export default API_AUTH_CONST;